import React, { useState } from 'react'
import PrivacyModalContext from '../context/PrivacyModalContext'

const PrivacyModalProvider = ({ children }) => {
  const [openModal, setOpenModal] = useState(false)
  return (<PrivacyModalContext.Provider
    value={{ openModal, setOpenModal }}>
    {children}
  </PrivacyModalContext.Provider>)
}

export default PrivacyModalProvider
